import { IFinancialLineItemExtendedDTO } from '@modeso/types__aumico-lib-settings-be';
import { createEntityAdapter, Dictionary, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, createSelector, MemoizedSelector, on } from '@ngrx/store';
import * as settingsActions from '../actions/settings.actions';
import { IFinancialLineItemState } from '../interfaces/financial-line-item-state.interface';

function selectFinancialLineItemId(a: IFinancialLineItemExtendedDTO): string {
    return a._id;
}

function sortByName(a: IFinancialLineItemExtendedDTO, b: IFinancialLineItemExtendedDTO): number {
    return a.name.localeCompare(b.name);
}

const adapter: EntityAdapter<IFinancialLineItemExtendedDTO> = createEntityAdapter<IFinancialLineItemExtendedDTO>({
    selectId: selectFinancialLineItemId,
    sortComparer: sortByName,
});

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

const selectEntity = createSelector(
    selectEntities,
    (entities: Dictionary<IFinancialLineItemExtendedDTO>, props: { id: string }) => entities[props.id],
);

export const initialFinancialLineItemState: IFinancialLineItemState = adapter.getInitialState({
    // additional entity state properties
    // activeVariable: null,
});

export function createSelectors<T>(financialLineItemStateSelector: MemoizedSelector<T, IFinancialLineItemState>) {
    return {
        selectAll: createSelector(financialLineItemStateSelector, selectAll),
        selectEntities: createSelector(financialLineItemStateSelector, selectEntities),
        selectActive: createSelector(financialLineItemStateSelector, (state) => state.activeFinancialLineItem),
        selectError: createSelector(financialLineItemStateSelector, (state) => state.error),
    };
}

const privateAccountingBasesReducer = createReducer(
    initialFinancialLineItemState,
    on(settingsActions.financialLineItemActions.onGetAllFinancialLineItemSuccess, (state, action) =>
        adapter.setAll(action.payload, { ...state, error: undefined }),
    ),
    on(settingsActions.financialLineItemActions.onGetAllFinancialLineItemFailed, (state, action) => ({
        ...state,
        error: action.payload,
    })),
    on(settingsActions.financialLineItemActions.setActiveFinancialLineItem, (state, action) => ({
        ...state,
        error: undefined,
        activeFinancialLineItem:
            typeof action.payload === 'string' ? selectEntity(state, { id: action.payload }) : action.payload,
    })),

    on(settingsActions.financialLineItemActions.onSubmitCreateFinancialLineItemSuccess, (state, action) => ({
        ...state,
        error: undefined,
        activeFinancialLineItem: null,
    })),
    on(settingsActions.financialLineItemActions.onSubmitCreateFinancialLineItemFailed, (state, action) => ({
        ...state,
        error: action.payload,
    })),

    on(settingsActions.financialLineItemActions.onSubmitEditFinancialLineItemSuccess, (state, action) => ({
        ...state,
        error: undefined,
        activeFinancialLineItem: null,
    })),
    on(settingsActions.financialLineItemActions.onSubmitEditFinancialLineItemFailed, (state, action) => ({
        ...state,
        error: action.payload,
    })),
);

export function financialLineItemsReducer(state: IFinancialLineItemState | undefined, action: Action) {
    return privateAccountingBasesReducer(state, action);
}
